export const managementPageTitleSx = {
  fontSize: '34px',
  lineHeight: '40px',
  letterSpacing: '-0.25px',
  fontWeight: 700,
  color: '#1C1B1F',
  mb: 1,
};

export const managementPageSubtitleSx = {
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#1C1B1F',
};

export const managementHeaderSx = {
  display: 'grid',
  gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 1fr) auto' },
  alignItems: 'start',
  gap: 2,
  mb: 4,
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
};

export const managementHeaderContentSx = {
  width: '100%',
  minWidth: 0,
  maxWidth: '100%',
};

export const managementHeaderActionSx = {
  minWidth: 0,
  width: { xs: '100%', md: 'auto' },
  maxWidth: '100%',
  display: 'flex',
  justifyContent: { xs: 'stretch', md: 'end' },
};

export const managementCreateButtonSx = {
  minWidth: 220,
  height: 56,
  px: 3,
  borderRadius: '8px',
  textTransform: 'uppercase',
  bgcolor: '#4F8506',
  color: '#FFFFFF',
  fontSize: 14,
  lineHeight: '20px',
  letterSpacing: '0.7px',
  fontWeight: 700,
  boxShadow: 'none',
  '&:hover': {
    bgcolor: '#4F8506',
    boxShadow: 'none',
  },
};
